export default __webpack_public_path__ + "static/media/prev-Marine-Receiver-2.2ab53837.png";